import React from 'react';

export default {
    TradChn : {
        formTitle: "網上表格",
        
        steps_Application: "申請內容",

        steps_Particulars: "表格詳情",
        
        field_CustomerTitle: "稱謂",
        field_CustomerTitle_list: [
            {id: "CustomerTitle", value: "Mr", text: "先生"},
            {id: "CustomerTitle", value: "Mrs", text: "太太"},
            {id: "CustomerTitle", value: "Ms", text: "女士"},
            {id: "CustomerTitle", value: "Miss", text: "小姐"},
        ],
        
        field_CustomerLastName: "姓",

        field_CustomerFirstName: "名",

        field_TelephoneNo: "電話號碼",

        field_EmailPostal: "電郵/郵寄地址",

        field_Message: "信息",

        field_Attachments_1: "附件1",

        field_Attachments_2: "附件2",

        field_Attachments_3: "附件3",

        acceptPrivacyPolicy: () => [<>我已閱讀並同意土地註冊處的<a href="http://www.landreg.gov.hk/tc/privacy.htm" target="_blank">私隱政策</a></>],

        Privacy: "私隱政策" ,

        notice_body: ()=> [
            <>
            
                <span>此表格內所有個人資料均予絕對保密，你的個人資料只會用作跟進用途。</span><br/>
            </>
            ]
            
        ,

        privacyPolicy_body: ()=> [
            <>
            
                <p>土地註冊處會確保所有透過本網頁遞交的個人資料，均按照<a href="http://www.pcpd.org.hk/tc_chi/data_privacy_law/ordinance_at_a_Glance/ordinance.html" target="_blank">《個人資料(私隱)條例》</a>的有關條文處理。</p>
                <p>土地註冊處會記錄使用者瀏覽本網頁的次數，但並不會收集任何足以辨識使用者身分的資料。所收集的瀏覽次數紀錄只會用於製作統計報告及調查電腦系統問題，以助土地註冊處改善本網頁和服務。</p>
                <p>土地註冊處可能會於不同期間及為個別原因，邀請你自願提供個人資料。此等資料可能包括姓名、年齡、教育程度、職業、電話號碼、郵寄地址或電郵地址。土地註冊處邀請你提供資料時，會列明收集資料的目的和用途。</p>
                <p>除非法律許可或有所規定，土地註冊處不會在未得到你的同意下透露你的個人資料予第三者。</p>
                <p>你向土地註冊處網頁提供的所有個人資料將予以保密，只供獲得授權的人員查閱。</p>
                <p>本網頁的搜尋服務是由一個政府的獨立承辦商提供。該獨立承辦商通知我們該公司於本網頁提供搜尋結果時，不會收集可識別個人身分的資料。但該獨立承辦商會將你一些經由使用搜尋服務所得的匿名資料交予政府，作政府網站流量分析之用。政府不會從任何上述搜尋活動收集到的數據，跟任何 可能由政府持有的個人身分資料配對。</p>
            </>
            ]
            
        ,

        acknowledgement_para1: "本處將處理你已遞交的表格。",

        acknowledgement_para2: "如欲就是次表格作出查詢，請提供以下參考編號。",

        ack_refNum: "表格參考編號",
    }
}
    
    